







































import _, { keyBy } from "lodash";
import { UIModel } from "../../UIModel";
import { Prop, Component, Vue } from "vue-property-decorator";
import { ACCProjectRequestAccess } from "./../../model/ACCProjectRequestAccess";
import { ERegion } from "@/model/ERegion";
import { BackendACCRole } from "@/model/backend/BackendACCRole";
import { EPlatform } from "@/model/EPlatform";

enum EmailStatus {
	SENDING = 'Send Email',
	// SUCCESS = 'Sent Email Successfully',
	// FAIL = 'Failed to Send Email',
	CLOSE = 'Close',
}

@Component({
  components: {

  },
})

export default class RequestAccessModal extends Vue {
  	// Props
	@Prop({ required: true }) public model!: UIModel;

	public show: boolean = false;

	public isLoading = false;

	public sendButtonText: EmailStatus = EmailStatus.SENDING;

	public EmailStatus = EmailStatus;

	public projectInfo: ACCProjectRequestAccess = {
		projectName: "",
		projectID: "",
		roleName: "",
		roleID: "",
		reasonForAccess: "",
		userEmail: String(this.model.user?.email),
		accountID: String(this.model.selectedHub?.id.replace("b.", "")),
		region: this.model.selectedHub?.region as ERegion,
		platform: EPlatform.ACC,
	}

	public get isFormValid() {
		return (
			this.projectInfo.projectName !== '' && 
			// this.projectInfo.roleID!== '' && 
			this.projectInfo.reasonForAccess !== ''
		);
	}

	public cancel(): void {
		this.show = false;
		this.resetSendButton();
	}

	public open(input: { projectName: string, projectID: string, platform: EPlatform, role?: string, message?: string }): void {
		this.projectInfo.projectName = input.projectName;

		this.projectInfo.projectID = input.projectID;

		this.projectInfo.platform = input.platform;
		
		this.projectInfo.accountID = String(this.model.selectedHub?.id.replace("b.", ""));
		
		this.projectInfo.region = this.model.selectedHub?.region as ERegion;

		this.show = !this.show;

		console.log("modal open", input);
		
		console.log("this.projectInfo", this.projectInfo);
	}

	get roles(): BackendACCRole[] {
		// if(!this.model.selectedHub)return [];
		// const hub = this.model.settings.licenses
		// 			.flatMap((license) => license.metadata?.hubs)
  		// 			.find((hub) => hub?.hubId === this.model.selectedHub?.id);
		// if(hub?.accProjectRolesList) return hub.accProjectRolesList
		return this.model.accProjectRolesList;
	}

	get isMobile(): boolean {
		if (window) {
			return window.innerWidth < 768;
		} else {
			return false;
		}
	}

	public async send() {
		if(this.sendButtonText != EmailStatus.SENDING) {
			this.cancel();
			return;
		}

		try {
			this.isLoading = true;
			await new Promise((resolve, reject) => setTimeout(resolve, 3000));
			this.projectInfo.roleName = String(this.roles.find(r => r.id == this.projectInfo.roleID)?.name);
			console.log("this.projectInfo: ", this.projectInfo);
			await this.model.sendAccProjectRequestAccess(this.projectInfo);
			(window as any).vue.$buefy.snackbar.open({
                indefinite: true,
                message: "Email sent successfully",
                actionText: 'OK',
                type: 'is-success',
                position: "is-bottom-right",
                queue: false,
                onAction: () => {
                    
                }
            });
		} catch (error) {
			// this.sendButtonText = EmailStatus.FAIL;
			(window as any).vue.$buefy.snackbar.open({
                indefinite: true,
                message: "Failed to send email. Please try it later.",
                actionText: 'OK',
                type: 'is-danger',
                position: "is-bottom-right",
                queue: false,
                onAction: () => {
                    
                }
            });
		} finally {
			this.isLoading = false;
			this.sendButtonText = EmailStatus.CLOSE;
			// this.cancel();
		}
	}

	public resetSendButton() {
		this.projectInfo.projectName = "";
		this.projectInfo.projectID = "";
		this.projectInfo.roleName = "";
		this.projectInfo.roleID = "";
		this.projectInfo.reasonForAccess = "";
		this.sendButtonText = EmailStatus.SENDING;
	}
}
